export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const PROTECTEDPAGE = "/protected";

export const TICKETSPAGE = "/tickets";
export const PROFILEPAGE = "/profile";
export const FAVORITESPAGE = "/favorites";
export const SHOPPINGHISTORYPAGE = "/shoppinghistory";

